'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _VstComponent2 = require('./VstComponent');

var _VstComponent3 = _interopRequireDefault(_VstComponent2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _copyProps = require('../utils/copy-props');

var _copyProps2 = _interopRequireDefault(_copyProps);

var _namespaceOptions = require('../utils/namespace-options');

var _namespaceOptions2 = _interopRequireDefault(_namespaceOptions);

var _addClassName = require('../utils/add-class-name');

var _addClassName2 = _interopRequireDefault(_addClassName);

var _glamor = require('glamor');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var iIcon = function iIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      xmlns: 'http://www.w3.org/2000/svg',
      width: '12',
      height: '12',
      viewBox: '0 0 12 12'
    }, props),
    _react2.default.createElement('path', {
      fill: '#777',
      className: 'st0',
      d: 'M6 .9c2.8 0 5.1 2.3 5.1 5.1S8.8 11.1 6 11.1.9 8.8.9 6 3.2.9 6 .9M6 0C2.7 0 0 2.7 0 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6z'
    }),
    _react2.default.createElement('path', {
      fill: '#777',
      className: 'st0',
      d: 'M4.8 9.3c.2 0 .3-.1.4-.1 0-.1.1-.2.1-.5V5.6c0-.2 0-.4-.1-.4-.1-.1-.2-.1-.4-.1v-.3h2v4c0 .2 0 .4.1.4.1.1.2.1.4.2v.2H4.8v-.3zm.7-6.7c.1-.1.3-.2.5-.2s.4.1.6.2c.1.2.2.4.2.6s-.1.4-.2.6c-.2.1-.4.2-.6.2-.2 0-.4-.1-.5-.2-.2-.2-.3-.4-.3-.6 0-.2.1-.4.3-.6z'
    })
  );
};

var errorIcon = function errorIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      xmlns: 'http://www.w3.org/2000/svg',
      width: '14',
      height: '14',
      viewBox: '0 0 14 14'
    }, props),
    _react2.default.createElement('circle', {
      className: 'st0',
      cx: '7',
      cy: '7',
      r: '7',
      fill: '#F54250'
    }),
    _react2.default.createElement('path', {
      fill: '#FFF',
      d: 'M6 3h2v4H6zM6 9h2v2H6z'
    })
  );
};

var VstInput = function (_VstComponent) {
  _inherits(VstInput, _VstComponent);

  function VstInput() {
    _classCallCheck(this, VstInput);

    return _possibleConstructorReturn(this, (VstInput.__proto__ || Object.getPrototypeOf(VstInput)).apply(this, arguments));
  }

  _createClass(VstInput, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.renderTooltip = this.renderTooltip.bind(this);
      this._isCheckboxOrRadio = this._isCheckboxOrRadio.bind(this);
    }
  }, {
    key: '_preventDefault',
    value: function _preventDefault(e) {
      e.preventDefault();
    }
  }, {
    key: '_isCheckboxOrRadio',
    value: function _isCheckboxOrRadio() {
      return this.props.type === 'checkbox' || this.props.type === 'radio';
    }
  }, {
    key: '_getCSS',
    value: function _getCSS() {
      return {
        '&:focus': {
          borderColor: this._theme(6)
        },
        '&[type="submit"]': {
          backgroundColor: this._theme(7),
          ':hover': {
            backgroundColor: this._theme(8)
          }
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var theme = (0, _glamor.css)(this._getCSS());
      var failureId = this.props.id + '-failure';

      var props = (0, _addClassName2.default)(this.props, (0, _classnames2.default)('vst-input', (0, _namespaceOptions2.default)('vst', this.props.options), { failure: this.props.failure }, theme.toString()));
      props = (0, _copyProps2.default)(props, ['failure', 'tooltip', 'tooltipConf', 'options', 'label', 'ignoreLabel']);
      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('vst-form-group', 'vst-form-group-' + this.props.type, (0, _namespaceOptions2.default)('vst-form-group', this.props.options)) },
        !this._isCheckboxOrRadio() && this.renderLabel(),
        this.renderTooltip(),
        _react2.default.createElement('input', _extends({ 'aria-required': this.props.required, 'aria-describedby': failureId, 'aria-invalid': !!this.props.failure }, props)),
        this._isCheckboxOrRadio() && this.renderLabel(),
        this.renderFailure(failureId)
      );
    }
  }, {
    key: 'renderLabel',
    value: function renderLabel() {
      if (this.props.type !== 'submit' && !this.props.ignoreLabel) {
        return _react2.default.createElement(
          'label',
          { className: 'vst-label vst-label-' + this.props.type, htmlFor: this.props.id },
          _react2.default.createElement(
            'span',
            { style: this.props.hideLabel ? {
                // https://webaim.org/techniques/css/invisiblecontent/#absolutepositioning
                position: 'absolute',
                left: '-10000px',
                top: 'auto',
                width: '1px',
                height: '1px',
                overflow: 'hidden'
              } : {}
            },
            this.props.label
          ),
          this.props.failure && this._isCheckboxOrRadio() && _react2.default.createElement(
            'span',
            { className: 'vst-label-icon' },
            errorIcon()
          )
        );
      }
      return null;
    }
  }, {
    key: 'renderFailure',
    value: function renderFailure(failureId) {
      if (this.props.failure) {
        return _react2.default.createElement(
          'div',
          { id: failureId, role: 'alert', className: (0, _classnames2.default)('vst-failure-message', { visible: this.props.failure }) },
          this.props.failure
        );
      }
      return null;
    }
  }, {
    key: 'renderTooltip',
    value: function renderTooltip() {
      if (this.props.tooltip) {
        return _react2.default.createElement(
          'span',
          { className: 'vst-label-icon',
            onMouseOver: this._preventDefault,
            'data-vst-tooltip-conf': this.props.tooltipConf,
            'data-vst-tooltip': this.props.tooltip
          },
          iIcon()
        );
      }
      return null;
    }
  }]);

  return VstInput;
}(_VstComponent3.default);

exports.default = VstInput;


VstInput.propTypes = {
  id: _propTypes2.default.string.isRequired,
  ignoreLabel: _propTypes2.default.bool,
  label: _propTypes2.default.string,
  tooltipConf: _propTypes2.default.string,
  failure: _propTypes2.default.node,
  type: _propTypes2.default.string,
  checkLabel: function checkLabel(props) {
    var isValid = props.ignoreLabel || props.label;
    return !isValid && new Error('VstInput requires a label');
  },
  hideLabel: _propTypes2.default.bool
};

VstInput.defaultProps = {
  tooltipConf: 'multiline',
  type: 'text'
};


/** WEBPACK FOOTER **
 ** ./~/vstui/lib/components/VstInput.js
 **/